import {tokens} from '@pleo-io/telescope'
import styled, {css} from 'styled-components'

import {Section} from '@helios/shared/styles/grid'
import {colors, radii} from '@helios/shared/theme'
import mq from '@helios/shared/utils/media-query'

export const Wrapper = styled(Section)`
    display: grid;
    row-gap: ${tokens.spacing32};
`

interface CarouselDotsProps {
    $showOn?: 'mobile' | 'desktop'
}

export const CarouselDots = styled.nav<CarouselDotsProps>(({$showOn}) => {
    const bp = 'sm'

    return css`
        display: grid;
        grid-auto-flow: column;
        gap: ${tokens.spacing20};
        align-items: center;
        justify-content: start;

        ${mq.max(bp)} {
            display: ${$showOn === 'desktop' && 'none'};
        }

        ${mq.min(bp)} {
            display: ${$showOn === 'mobile' && 'none'};
        }
    `
})

interface CarouselDotProps {
    $isActive?: boolean
}

export const CarouselDot = styled.button<CarouselDotProps>(({$isActive}) => {
    const isActiveStyles = css`
        width: 20px;
        height: 20px;
        background: ${colors.background.tertiary};
    `

    return css`
        width: 16px;
        height: 16px;
        padding: 0;
        cursor: pointer;
        background: ${colors.background.secondary};
        border: none;
        border-radius: ${radii.circle};

        ${$isActive && isActiveStyles}
    `
})
